import { createContext, useContext } from 'react';
const PageContext = createContext(null);
export function usePageContext() {
    const ctx = useContext(PageContext);
    if (!ctx) {
        throw new Error('usePageContext must be used within Page');
    }
    return ctx;
}
export default PageContext;
